import axios from "axios";
import QS from 'qs';
import {
	Notification
} from 'element-ui';
import router from "../../router/index.js"
// 环境的切换
if (process.env.NODE_ENV == 'development') {
	console.log('环境', 'development')
	axios.defaults.baseURL = 'http://gateway.zhenyuanma.com';
} else if (process.env.NODE_ENV == 'production') {
	console.log('环境', 'production')
	axios.defaults.baseURL = 'http://gateway.zhenyuanma.com';
}

//设置请求超时
axios.defaults.timeout = 10000;

// 请求拦截器
axios.interceptors.request.use(
	config => {
		return config;
	},
	error => {
		return Promise.error(error);
	})

// 响应拦截器
axios.interceptors.response.use(
	response => {
		if (response.status === 200) {
			if (!response.data.code) {
				return Promise.resolve(response.data)
			} else {
				if (response.data.code == 0) {
					return Promise.resolve(response.data)
				} else {
					return Promise.reject(response)
				}
			}
		} else {
			return Promise.reject(response)
		}
	},
	// 服务器状态码不是200的情况    
	error => {
		if (error.response.status) {
			switch (error.response.status) {
				// 401: 未登录                
				// 未登录则跳转登录页面，并携带当前页面的路径                
				// 在登录成功后返回当前页面，这一步需要在登录页操作。                
				case 401:
					localStorage.clear();
					router.replace({
						path: '/login',
						query: {
							redirect: router.currentRoute.fullPath
						}
					});
					break;

					// 403 token过期                
					// 登录过期对用户进行提示                
					// 清除本地token和清空vuex中token对象                
					// 跳转登录页面                
				case 403:
					localStorage.clear();
					Notification.error({
						title: '错误',
						message: '登录失效,请重新登录!'
					});
					setTimeout(() => {
						router.replace({
							path: '/login',
							query: {
								redirect: router.currentRoute.fullPath
							}
						});
					}, 1200);
					break;

					// 404请求不存在                
				case 404:
					Notification.error({
						title: '错误',
						message: '网络请求不存在!'
					});
					break;

					//服务器内部错误
				case 500:
					Notification.error({
						title: '错误',
						message: '服务器内部错误,请联系管理员解决!'
					});
					break;

					// 其他错误，直接抛出错误提示                
				default:
					console.log("error", error)
					Notification.error({
						title: '错误',
						message: '请求失败,请稍后重试!'
					});
			}
			return Promise.reject(error.response);
		}
	}
);

export default axios;
